
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomains/[subdomain]/event/[eventId]/live",
      function () {
        return require("private-next-pages/_subdomains/[subdomain]/event/[eventId]/live.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomains/[subdomain]/event/[eventId]/live"])
      });
    }
  